var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thumb_up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.99935 14.6667H11.9993C12.5527 14.6667 13.026 14.3333 13.226 13.8533L15.2393 9.15333C15.2993 8.99999 15.3327 8.83999 15.3327 8.66666V7.33333C15.3327 6.6 14.7327 6 13.9993 6H9.79268L10.426 2.95333L10.446 2.73999C10.446 2.46666 10.3327 2.21333 10.1527 2.03333L9.44602 1.33333L5.05268 5.72666C4.81268 5.96666 4.66602 6.29999 4.66602 6.66666V13.3333C4.66602 14.0667 5.26602 14.6667 5.99935 14.6667ZM5.99935 6.66666L8.89268 3.77333L7.99935 7.33333H13.9993V8.66666L11.9993 13.3333H5.99935V6.66666ZM0.666016 6.66666H3.33268V14.6667H0.666016V6.66666Z",
    fill: "#5B6670"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/ThumbUp.f7a4d46c30b1b22f11cc0cf972cde772.svg";
export { ForwardRef as ReactComponent };